import { Component, OnChanges, AfterViewInit, Input } from '@angular/core';

declare var window: any;
@Component({
  selector: 'form-render',
  template: '<div></div>'
})
export class FormRenderComponent implements AfterViewInit, OnChanges{
  @Input() json: string;
  @Input() data: any;

  constructor() {}

  ngOnChanges(changes) {
    for (let propName in changes) {
      let change = changes[propName];
      if(!change.isFirstChange()) {
        window.formReRender(propName, this.data, function() {
          Object.assign(this.data, '');
        });
      }
    }
  }

  ngAfterViewInit(): void {
    window.formRender(this.json, this.data, function(){});
  }

}
